import * as Types from '../../types.generated';

import { gql } from '@apollo/client';
import { MyTranslationSetFragmentDoc } from '../../fragments.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type MyTrainingFoodHandlerModulesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type MyTrainingFoodHandlerModulesQuery = { __typename?: 'Query', PremiumContentConfigs: { __typename?: 'PremiumContentConfigs', objects: Array<{ __typename?: 'PremiumContentConfig', id: number, catalogModule?: { __typename?: 'CatalogModule', id: string, module: { __typename?: 'Module', id: number, libraryItem: { __typename?: 'LibraryItem', id: string } } } | null }> } };

export type MyTrainingFoodHandlerExamsQueryVariables = Types.Exact<{
  input: Types.AssignmentsInput;
  pagination?: Types.InputMaybe<Types.PaginationInput>;
}>;


export type MyTrainingFoodHandlerExamsQuery = { __typename?: 'Query', Assignments: { __typename?: 'Assignments', objects: Array<{ __typename?: 'Assignment', id: string, libraryItem: { __typename?: 'LibraryItem', id: string, name: { __typename?: 'TranslationSet', uuid: string, myTranslation: string } }, currentModuleInstance?: { __typename?: 'ModuleInstance', id: string, createdAt: string, completedAt?: string | null, foodHandlerExam?: { __typename?: 'FoodHandlerExam', id: string, passed: boolean, link: string } | null } | null }> } };


export const MyTrainingFoodHandlerModulesDocument = gql`
    query MyTrainingFoodHandlerModules {
  PremiumContentConfigs(input: {complianceTypes: [FOOD_HANDLER, FOOD_MANAGER]}) {
    objects {
      id
      catalogModule {
        id
        module {
          id
          libraryItem {
            id
          }
        }
      }
    }
  }
}
    `;

/**
 * __useMyTrainingFoodHandlerModulesQuery__
 *
 * To run a query within a React component, call `useMyTrainingFoodHandlerModulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyTrainingFoodHandlerModulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyTrainingFoodHandlerModulesQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyTrainingFoodHandlerModulesQuery(baseOptions?: Apollo.QueryHookOptions<MyTrainingFoodHandlerModulesQuery, MyTrainingFoodHandlerModulesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyTrainingFoodHandlerModulesQuery, MyTrainingFoodHandlerModulesQueryVariables>(MyTrainingFoodHandlerModulesDocument, options);
      }
export function useMyTrainingFoodHandlerModulesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyTrainingFoodHandlerModulesQuery, MyTrainingFoodHandlerModulesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyTrainingFoodHandlerModulesQuery, MyTrainingFoodHandlerModulesQueryVariables>(MyTrainingFoodHandlerModulesDocument, options);
        }
export type MyTrainingFoodHandlerModulesQueryHookResult = ReturnType<typeof useMyTrainingFoodHandlerModulesQuery>;
export type MyTrainingFoodHandlerModulesLazyQueryHookResult = ReturnType<typeof useMyTrainingFoodHandlerModulesLazyQuery>;
export type MyTrainingFoodHandlerModulesQueryResult = Apollo.QueryResult<MyTrainingFoodHandlerModulesQuery, MyTrainingFoodHandlerModulesQueryVariables>;
export const MyTrainingFoodHandlerExamsDocument = gql`
    query MyTrainingFoodHandlerExams($input: AssignmentsInput!, $pagination: PaginationInput) {
  Assignments(input: $input, pagination: $pagination) {
    objects {
      id
      libraryItem {
        id
        name {
          ...MyTranslationSet
        }
      }
      currentModuleInstance {
        id
        createdAt
        completedAt
        foodHandlerExam {
          id
          passed
          link
        }
      }
    }
  }
}
    ${MyTranslationSetFragmentDoc}`;

/**
 * __useMyTrainingFoodHandlerExamsQuery__
 *
 * To run a query within a React component, call `useMyTrainingFoodHandlerExamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyTrainingFoodHandlerExamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyTrainingFoodHandlerExamsQuery({
 *   variables: {
 *      input: // value for 'input'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useMyTrainingFoodHandlerExamsQuery(baseOptions: Apollo.QueryHookOptions<MyTrainingFoodHandlerExamsQuery, MyTrainingFoodHandlerExamsQueryVariables> & ({ variables: MyTrainingFoodHandlerExamsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyTrainingFoodHandlerExamsQuery, MyTrainingFoodHandlerExamsQueryVariables>(MyTrainingFoodHandlerExamsDocument, options);
      }
export function useMyTrainingFoodHandlerExamsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyTrainingFoodHandlerExamsQuery, MyTrainingFoodHandlerExamsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyTrainingFoodHandlerExamsQuery, MyTrainingFoodHandlerExamsQueryVariables>(MyTrainingFoodHandlerExamsDocument, options);
        }
export type MyTrainingFoodHandlerExamsQueryHookResult = ReturnType<typeof useMyTrainingFoodHandlerExamsQuery>;
export type MyTrainingFoodHandlerExamsLazyQueryHookResult = ReturnType<typeof useMyTrainingFoodHandlerExamsLazyQuery>;
export type MyTrainingFoodHandlerExamsQueryResult = Apollo.QueryResult<MyTrainingFoodHandlerExamsQuery, MyTrainingFoodHandlerExamsQueryVariables>;